import { storeToRefs } from 'pinia';
import mainStore from '@/stores/main-store';

const useMainStore = () => {
    const { setAccessToken, setUsername, setPermissions } = mainStore();

    const { accessToken, oid, attributeStoreData, username, permissions, roles, shippers, activeShippers } = storeToRefs(mainStore());

    return {
        accessToken,
        username,
        setAccessToken,
        setUsername,
        oid,
        roles,
        attributeStoreData,
        setPermissions,
        permissions,
        shippers,
        activeShippers
    };
};

export default useMainStore;
